import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFireDatabase } from 'angularfire2/database'

@Pipe({
  name: 'filtrarViajesPorAprobacion'
})
export class FiltrarViajesPorAprobacion implements PipeTransform {
    constructor(public af:AngularFireDatabase){}
    transform(arregloViajes:any, filtro:any): any {
        // Arreglo de unidades que se van a mostrar
        let operadoresFiltrados:Array<any> = [];
        // Hace un loop por las unidades proporcionados para poder filtrarlos por id de operador
        if(arregloViajes != undefined)
            arregloViajes.forEach(viaje => {
                if(filtro != ''){
                    if(filtro == "Si" && viaje.viajeAceptado)
                        operadoresFiltrados.push(viaje)
                    else {
                        if(filtro == "No" && !viaje.viajeAceptado)
                            operadoresFiltrados.push(viaje)
                    }
                }else{
                    operadoresFiltrados= arregloViajes
                }
            });
    return operadoresFiltrados;
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-viajes-por-aprobacion.pipe.ts